
import { type ReactNode } from 'react'
import WorldRing from './WorldRing'

const chip =
  'inline-flex items-center gap-2 rounded-full border border-white bg-white/85 px-3 py-1.5 text-xs font-semibold text-[#0B1E3F] shadow-sm'

export default function AuthLayout({ children }: { children: ReactNode }) {
  return (
    <div className="flex min-h-dvh select-none flex-col bg-gradient-to-br from-[#BFD8FA] via-[#E9F1FD] to-[#F5EFFC] font-sans text-[#0B1E3F] [-webkit-tap-highlight-color:transparent] [&_input]:select-text">


      <main className="mx-auto grid w-full max-w-7xl flex-1 items-center gap-8 px-4 py-6 lg:grid-cols-[1.25fr_1fr] lg:gap-10 lg:px-10">
        {/* LEFT: branding */}
        <section className="text-center lg:text-left">


          <h1 className="mt-3 text-3xl font-extrabold leading-[1.1] tracking-tight sm:text-4xl lg:text-5xl">
            Lincoln International
            <br />
            SDG &amp; Cultural Day 2026
          </h1>

          <p className="mt-3 text-lg font-bold italic text-orange-500 sm:text-2xl">
            “99 Countries, One Experience”
          </p>
          {/* World Ring — responsive */}
          <div className="mt-6 flex w-full justify-center lg:mt-10 lg:justify-start">
            <WorldRing
              className="
      h-[220px]
      w-[220px]
      sm:h-[200px]
      sm:w-[150px]
      md:h-[150px]
      md:w-[340px]
      lg:h-[min(44vh,420px)]
      lg:w-[min(44vh,420px)]
    "
            />
          </div>
          <p className="mt-6 hidden lg:block text-sm text-slate-700">
            hosted by the <b className="font-semibold text-blue-700">SDG &amp; Cultural Committee</b> of Lincoln University College Malaysia[cite: 1], this event celebrates the United Nations Sustainable Development Goals and the diversity of cultures in our student body.
          </p>
        </section>

        {/* RIGHT: form */}
        <section className="flex justify-center">{children}</section>
      </main>

      <footer className="px-3 py-3 text-center text-[11px] text-slate-500">
        Technology Partner:{' '}
        <a
          href="https://www.techvisionsoft.com"
          target="_blank"
          rel="noopener noreferrer"
          className="font-semibold text-slate-700 transition-colors hover:text-blue-600"
        >
          Techvision Softwares Sdn. Bhd.
        </a>

        <span className="hidden sm:inline">
          {' · '}
          <a
            href="https://www.techvisionsoft.com"
            target="_blank"
            rel="noopener noreferrer"
            className="transition-colors hover:text-blue-600"
          >
            www.techvisionsoft.com
          </a>
        </span>
      </footer>
    </div>
  )
}
